var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCosmetic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3827 21.8002C43.3827 33.4546 33.9585 42.9002 22.3359 42.9002C10.7132 42.9002 1.28906 33.4546 1.28906 21.8002C1.28906 10.1458 10.7132 0.700195 22.3359 0.700195C33.9585 0.700195 43.3827 10.1458 43.3827 21.8002Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8323 20.7815C19.0323 20.3633 19.1443 19.8948 19.1443 19.4001C19.1443 19.1747 19.121 18.9548 19.0768 18.7427C20.0023 18.6491 20.9587 18.6001 21.9374 18.6001C30.0911 18.6001 36.7009 22.0027 36.7009 26.2001C36.7009 30.3975 30.0911 33.8001 21.9374 33.8001C13.7837 33.8001 7.17383 30.3975 7.17383 26.2001C7.17383 23.7643 9.3999 21.5961 12.8619 20.2052C13.0396 20.8926 13.4396 21.4903 13.9803 21.9167C13.4177 22.1267 12.8937 22.357 12.4134 22.6043C9.97528 23.8594 9.17383 25.2365 9.17383 26.2001C9.17383 27.1637 9.97528 28.5408 12.4134 29.7959C14.7478 30.9976 18.1119 31.8001 21.9374 31.8001C25.7628 31.8001 29.127 30.9976 31.4614 29.7959C33.8995 28.5408 34.7009 27.1637 34.7009 26.2001C34.7009 25.2365 33.8995 23.8594 31.4614 22.6043C29.127 21.4026 25.7628 20.6001 21.9374 20.6001C20.8617 20.6001 19.8225 20.6636 18.8323 20.7815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5664 12.2993L15.9518 11.4411L16.3371 12.2993C17.0376 13.8593 18.2849 15.1088 19.8436 15.8122L20.7029 16.2L19.8436 16.5878C18.2849 17.2912 17.0376 18.5407 16.3372 20.1007L15.9518 20.9589L15.5664 20.1007C14.866 18.5407 13.6187 17.2912 12.06 16.5878L11.2007 16.2L12.06 15.8122C13.6187 15.1088 14.8659 13.8593 15.5664 12.2993Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmetic);
export default __webpack_public_path__ + "static/media/cosmetic.2e47acb2739f0760383badf78284d4d5.svg";
export { ForwardRef as ReactComponent };